import { render } from "./ComponenteCompresor.vue?vue&type=template&id=60ac99fb&scoped=true"
import script from "./ComponenteCompresor.vue?vue&type=script&lang=js"
export * from "./ComponenteCompresor.vue?vue&type=script&lang=js"

import "./ComponenteCompresor.vue?vue&type=style&index=0&id=60ac99fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ac99fb"]])

export default __exports__